<app-modal-template
  [title]="'Change language' | translate"
  [size]="'medium'"
  [hasCloseButton]="true"
  (closeButtonClicked)="dialogRef.close()"
>
  <div content-description [innerHTML]="message"></div>
  <div content-actions>
    <app-pencil-button
      [theme]="'primary'"
      (clickEvent)="updateLanguage(data?.target?.code)"
      icon="check"
      [iconConfig]="{ type: 'material-icon' }"
      [label]="'Refresh to change language' | translate"
    ></app-pencil-button>
  </div>
</app-modal-template>
